import { render, staticRenderFns } from "./InspectionListEditForm.vue?vue&type=template&id=2cc1ccf5&scoped=true&"
import script from "./InspectionListEditForm.vue?vue&type=script&lang=ts&"
export * from "./InspectionListEditForm.vue?vue&type=script&lang=ts&"
import style0 from "./InspectionListEditForm.vue?vue&type=style&index=0&id=2cc1ccf5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc1ccf5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VContainer,VForm,VIcon,VRow})
